import { message } from 'antd';
import { Form } from '@ant-design/compatible';
import { filter, findIndex, includes, isNil, sortBy } from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { scroller } from 'react-scroll';
import {
  MINIMUM_NUMBER_OF_TAG_RELATION_COUNT,
  NUMBER_OF_TAG_TREND_MAIN_ITEM_COUNT,
  TAG_EDIT_PAGE_PANEL_NAME,
  TAG_STATUS,
} from '../../constants/service/app/tagConstants';
import { asyncSimpleModal, setTrim } from '../../lib/common';
import { tagActions } from '../../store/modules/tag';
import TagEditWrap from '../../views/tag/edit/TagEditWrap';

class TagEditContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { prepareInsertTag } = this.props;
    prepareInsertTag();
  };

  /**
   *  태그 등록/편집 하기
   */
  onSubmit = async (status) => {
    const { form, tagEdit, onSubmit } = this.props;
    const { tagInfo, tagTabMain } = tagEdit;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 150, offsetTop: 150 } }, async (err) => {
      if (err) return;

      /**
       *  태그명 중복 검사 체크
       */
      if (tagInfo.isDuplicationTagName) {
        message.error('이미 등록된 태그명입니다.');
        scroller.scrollTo(TAG_EDIT_PAGE_PANEL_NAME.TAG_EDIT_INFO);
        return;
      }

      /**
       *  연관된 태그 최소 개수 체크
       */
      if (!tagInfo.relatedTagList || tagInfo.relatedTagList.length < MINIMUM_NUMBER_OF_TAG_RELATION_COUNT) {
        message.error(`연관된 태그는 최소 ${MINIMUM_NUMBER_OF_TAG_RELATION_COUNT}개이상입니다.`);
        scroller.scrollTo(TAG_EDIT_PAGE_PANEL_NAME.TAG_EDIT_INFO);
        return;
      }

      // /**
      //  *  태그의 대표 컨텐츠 아이템 개수 체크
      //  *  6개가 설정되어야 함
      //  */
      // if (!tagTabMain.selectedItemList.list || tagTabMain.selectedItemList.list.length !== NUMBER_OF_TAG_TREND_MAIN_ITEM_COUNT) {
      //     message.error("태그의 대표 컨텐츠 아이템 개수는 6개로 설정해야 합니다.");
      //     scroller.scrollTo(TAG_EDIT_PAGE_PANEL_NAME.TAG_EDIT_TAG_TREND_MAIN);
      //     return;
      // }

      onSubmit({
        /**
         *  태그 정보
         */
        tagInfo: {
          /**
           *  태그 id
           */
          tagId: tagInfo.tagId,
          /**
           *  태그명
           */
          tagName: setTrim(tagInfo.tagName),
          /**
           *  태그 상태
           */
          status: isNil(status) ? tagInfo.status : status,
          /**
           *  태그 그룹 id
           */
          tagGroupIdList: tagInfo.tagGroupIdList,
          /**
           *  연관 태그 리스트
           */
          relatedTagList: tagInfo.relatedTagList.map((item) => item.id),
          /**
           *  태그 이미지
           */
          tagImg: tagInfo.tagImg,
        },
        /**
         *  태그 트렌드 메인 아이템 리스트
         */
        tagTabMainContentList: tagTabMain.selectedItemList.list.map((item, index) => ({
          id: item.contentsId,
          no: index + 1,
          type: item.type,
        })),
      });
    });
  };

  /**
   *  추천 태그 리스트 요청하기
   */
  getRecommendTagList = () => {
    const { getRecommendTagList, tagEdit } = this.props;
    const { tagInfo } = tagEdit;
    const tagName = setTrim(tagInfo.tagName);

    if (!tagName || !tagName.length) {
      message.error('태그명을 먼저 입력해주세요.');
      return;
    }

    getRecommendTagList({
      keyword: tagName,
    });
  };

  /**
   *  태그명 중복검사하기
   */
  onChangeTagName = (value) => {
    const { setData, checkTagName, tagEdit } = this.props;
    const { tagInfo } = tagEdit;

    setData({
      path: ['tagEdit', 'tagInfo', 'tagName'],
      value,
    });

    const targetTagName = setTrim(value);

    if (targetTagName && targetTagName.length) {
      checkTagName({
        tagName: targetTagName,
        tagId: tagInfo.tagId,
      });
    }
  };

  /**
   *  추천 태그를 연관태그로 설정하기
   */
  selectRecommendTag = (recommendTag) => {
    const { form, setData, tagEdit } = this.props;
    const { tagInfo, recommendTagSelectList } = tagEdit;

    const updatedRelatedTagList = [...tagInfo.relatedTagList, recommendTag];

    form.setFieldsValue({
      relatedTagList: updatedRelatedTagList.map((tag) => tag.id),
    });

    /**
     *  선택한 추천 태그를 연관태그로 설정하기
     */
    setData({
      path: ['tagEdit', 'tagInfo', 'relatedTagList'],
      value: updatedRelatedTagList,
    });

    /**
     *  선택한 추천 태그를 추천 태그 리스트에서 제외하기
     */
    setData({
      path: ['tagEdit', 'recommendTagSelectList'],
      value: recommendTagSelectList.filter((tag) => tag !== recommendTag),
    });
  };

  /**
   *  태그의 대표 컨텐츠 아이템 선택하기
   */
  selectTagTrendMainItemList = async (action, moveIdList) => {
    const { setData, tagEdit } = this.props;
    const { tagTabMain } = tagEdit;
    const { itemList, selectedItemList } = tagTabMain;

    /**
     *  업데이트 될 선택된 태그의 대표 컨텐츠 아이템 리스트
     */
    let updatedSelectTagTrendMainItemList = [];

    /**
     *  태그의 대표 컨텐츠 아이템 추가
     */
    if (action === 'add') {
      let targetList = filter(itemList, (item) => includes(moveIdList, item.id));

      /**
       *  이전에 선택되어 있던 아이템 리스트와
       *  추가로 선택된 태그의 대표 컨텐츠 아이템을 합침
       */
      updatedSelectTagTrendMainItemList = [...targetList, ...selectedItemList.list];

      /**
       *  추가하려고 하는 태그의 대표 컨텐츠 아이템 개수가 초과되었을 경우
       */
      if (updatedSelectTagTrendMainItemList.length > NUMBER_OF_TAG_TREND_MAIN_ITEM_COUNT) {
        await asyncSimpleModal({
          type: 'error',
          title: '아이템 개수 초과',
          message: `태그의 대표 컨텐츠 아이템 개수는 최대 ${NUMBER_OF_TAG_TREND_MAIN_ITEM_COUNT} 입니다.`,
        });
        return;
      }
    } else if (action === 'remove') {
      /**
       *  태그의 대표 컨텐츠 아이템 해제
       */
      /**
       *  이전에 선택되어 있던 아이템 리스트에서
       *  해제한 아이템을 빼버림
       */
      updatedSelectTagTrendMainItemList = filter(selectedItemList.list, (item) => !includes(moveIdList, item.id));
    }

    /**
     *  선택되어진 선택된 아이템은
     *  선택할 수 없도록 함
     */
    const updatedTagTrendMainItemList = itemList.map((item) => ({
      ...item,
      uncheckable: includes(moveIdList, item.id) ? action === 'add' : item.uncheckable,
    }));
    setData({
      path: ['tagEdit', 'tagTabMain', 'itemList'],
      value: updatedTagTrendMainItemList,
    });

    /**
     *  선택된 아이템 업데이트하기
     */
    setData({
      path: ['tagEdit', 'tagTabMain', 'selectedItemList'],
      value: {
        list: updatedSelectTagTrendMainItemList,
        idList: updatedSelectTagTrendMainItemList.map((item) => item.id),
      },
    });
  };

  /**
   * 태그의 대표 컨텐츠 아이템 리스트 순서 변경하기
   */
  onDragEndSelectTagTrendMainItemList = async (newList) => {
    const { setData, tagEdit } = this.props;
    const { tagTabMain } = tagEdit;
    const { selectedItemList } = tagTabMain;

    const updatedSelectTagTrendMainItemList = sortBy(selectedItemList.list, (item) =>
      findIndex(newList, (_item) => _item.id === item.id),
    );

    await setData({
      path: ['tagEdit', 'tagTabMain', 'selectedItemList'],
      value: {
        list: updatedSelectTagTrendMainItemList,
        idList: updatedSelectTagTrendMainItemList.map((item) => item.id),
      },
    });
  };

  /**
   *  태그 미리보기
   */
  tagPreview = () => {
    const { tagEdit, getTagDetailPreviewData } = this.props;
    const { tagInfo, tagTabMain } = tagEdit;
    const { selectedItemList } = tagTabMain;

    getTagDetailPreviewData({
      tagInfo: {
        tagId: tagInfo.tagId,
        tagName: tagInfo.tagName,
      },
      tagMainTab: {
        itemList: selectedItemList.list.map((item) => ({
          id: item.id,
          url: item.url,
        })),
      },
      relatedTagList: tagInfo.relatedTagList,
    });
  };

  /**
   *  태그 등록 승인하기
   */
  permitRegistrationTag = async () => {
    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '태그 승인',
      message: '해당 태그를 승인하시겠습니까?',
    });

    if (!confirmResult) return;

    /**
     *  태그를 승인하는 경우,
     *  태그를 등록 할 때와 마찬가지로
     *  필수로 저장되어야 하는 데이터를 검사함
     */
    this.onSubmit(TAG_STATUS.active);
  };

  /**
   *  태그 등록 거절하기
   */
  rejectRegistrationTag = async () => {
    const { tagEdit, rejectRegistrationTag } = this.props;
    const { tagInfo } = tagEdit;

    const confirmResult = await asyncSimpleModal({
      type: 'confirm',
      title: '태그 등록 거절',
      message: '해당 태그를 등록 거절하시겠습니까?',
    });

    if (!confirmResult) return;

    rejectRegistrationTag({
      tagId: tagInfo.tagId,
    });
  };

  render() {
    const { form, tagEdit, tagGroupSelectList, setData, getTagSearchList } = this.props;

    return (
      <TagEditWrap
        form={form}
        tagEdit={tagEdit}
        tagGroupSelectList={tagGroupSelectList}
        setData={setData}
        onSubmit={this.onSubmit}
        onChangeTagName={this.onChangeTagName}
        getTagSearchList={getTagSearchList}
        selectRecommendTag={this.selectRecommendTag}
        getRecommendTagList={this.getRecommendTagList}
        selectTagTrendMainItemList={this.selectTagTrendMainItemList}
        onDragEndSelectTagTrendMainItemList={this.onDragEndSelectTagTrendMainItemList}
        tagPreview={this.tagPreview}
        permitRegistrationTag={this.permitRegistrationTag}
        rejectRegistrationTag={this.rejectRegistrationTag}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tagEdit: state.tag.tagEdit,
    tagGroupSelectList: state.tag.tagGroupSelectList,
  };
};

const mapDispatchToProps = {
  setData: tagActions.setData,
  prepareInsertTag: tagActions.prepareInsertTag,
  checkTagName: tagActions.checkTagName,
  getTagSearchList: tagActions.getTagSearchList,
  getRecommendTagList: tagActions.getRecommendTagList,
  getTagDetailPreviewData: tagActions.getTagDetailPreviewData,
  rejectRegistrationTag: tagActions.rejectRegistrationTag,
};

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(TagEditContainer));
